import { Component, OnInit } from '@angular/core';
import { SocketService } from './socket.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  username = '';
  recipient = '';
  message = '';
  messages: any[] = [];
  isRegistered = false;

  constructor(private socketService: SocketService) {}

  ngOnInit(): void {
    this.socketService.onMessage((msg) => {
      this.messages.push(msg);
    });
  }

  register(): void {
    if (!this.username.trim()) return;
    this.socketService.registerUser(this.username, (res) => {
      console.log('Register Response:', res);
      if (res.success) {
        this.isRegistered = true;
      } else {
        alert(res.msg);
      }
    });
  }

  send(): void {
    if (!this.recipient || !this.message) return;
    this.socketService.sendMessage(this.recipient, this.message, (res) => {
      console.log('Send Response:', res);
      if (!res.success) {
        alert(res.msg);
      }
      this.message = '';
    });
  }
}
